import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Priority } from '../model/Priority';
import { JdSearchSerializer } from '../model/serializer/jd-search-serializer'

import { environment } from '@environments/environment';
import { JdSearch } from '@app/model/jdSearch';

@Injectable({ providedIn: 'root' })
export class JdSearchService extends ApiService<JdSearch> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      '/job',
      new JdSearchSerializer());
  }
}
